import React from 'react';
import Modal from '../../components/common/Modal';
import Button from '../../components/common/Button';
import { useDispatch } from 'react-redux';
import { smsLoginSession } from './loginSlice';

const SMSList = ({ onClose, data, form }) => {
  const dispatch = useDispatch();

  const handleClick = item => {
    let data = {
      htmAuth: form.htmAuth,
      htmPhone: form.htmInsaPerHTel,
      htmComCd: item.htmComCd,
      htmPerSabun: item.htmPerSabun,
      htmAlias: item.htmAlias,
    };

    dispatch(smsLoginSession(data));
  };

  return (
    <Modal onClose={onClose} height={400} width="calc(100% - 40px)" innerStyle={{ padding: '20px' }}>
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        {data.map((item, index) => (
          <Button
            key={index}
            value={item.htmComNm + ' - ' + item.htmPerSabun}
            onClick={() => handleClick(item)}
            variant="outline"
          />
        ))}
      </div>
    </Modal>
  );
};

export default SMSList;
